const { BASE_URL } = require("./client");

const SIGN_IN_API = BASE_URL + "/signin";
const GOGGLE_LOGIN_API = BASE_URL + "/google_login";
const EMAIL_SUGGESTION = BASE_URL + "/api/email/suggestion";

export { SIGN_IN_API, GOGGLE_LOGIN_API, EMAIL_SUGGESTION };
